import { Modal, Slider } from "antd";
import React, { useEffect, useRef, useState } from "react";
import AvatarEditor from "react-avatar-editor";
import BaseButton from "../../Button/BaseButton";
import "../../../../assets/style/modalStyle/editImage.scss";
const ModalCropImage = ({
  title,
  isOpen,
  setIsOpen,
  setImage,
  image,
  widthImage,
  heightImage,
  setFile,
  setChanged,
}) => {
  const [slideValue, setSlideValue] = useState(100);
  const handleCancel = () => {
    setChanged(false);
    setIsOpen(false);
  };
  useEffect(() => {
    return () => setChanged(false);
  }, []);
  const editorRef = useRef();
  const handleSave = () => {
    const editor = editorRef.current;
    const canvas = editor.getImageScaledToCanvas();
    canvas.toBlob((blob) => {
      const desiredWidth = widthImage;
      const desiredHeight = heightImage;
      const resizedCanvas = document.createElement("canvas");
      resizedCanvas.width = desiredWidth;
      resizedCanvas.height = desiredHeight;
      const ctx = resizedCanvas.getContext("2d");
      ctx.drawImage(canvas, 0, 0, desiredWidth, desiredHeight);
      const imageUrl = URL.createObjectURL(blob);
      setImage(imageUrl);
      const resizedFile = new File([blob], "edited_image.jpg", {
        type: "image/jpeg",
      });
      setChanged(true);
      setFile(resizedFile);
      setIsOpen(false);
    }, "image/jpeg");
  };
  return (
    <Modal
      maskClosable={false}
      className="wrapperModalEditImage"
      centered
      width={widthImage * 2.5}
      open={isOpen}
      onCancel={handleCancel}
      footer={[
        <BaseButton
          width={120}
          content={"Cancel"}
          typeBtn="base"
          handleClick={handleCancel}
        />,
        <BaseButton
          content={"ok"}
          typeBtn="btnOrange"
          handleClick={handleSave}
          width={120}
        />,
      ]}
    >
      <AvatarEditor
        ref={editorRef}
        image={image}
        width={widthImage}
        height={heightImage}
        border={[widthImage / 2, 20]}
        color={[0, 0, 0, 0.4]}
        scale={slideValue / 100}
      />
      {/* <button onClick={handleSave}>Lưu và tải lên</button> */}
      <Slider
        min={0}
        max={200}
        className="slide"
        sx={{
          margin: "0 auto",
          width: "100%",
          color: "cyan",
        }}
        size="medium"
        defaultValue={slideValue}
        value={slideValue}
        onChange={(e) => setSlideValue(e)}
      />
    </Modal>
  );
};

export default ModalCropImage;
